export default [
    {
        date: 1584979585567,
        row: 12,
        col: 13,
        squares: [
            [1, 4, "#D9D9D9"],
            [2, 3, "#D9D9D9"],
            [2, 5, "#D9D9D9"],
            [3, 3, "#D9D9D9"],
            [3, 4, "#D9D9D9"],
            [3, 5, "#D9D9D9"],
            [1, 10, "#D9D9D9"],
            [2, 9, "#D9D9D9"],
            [2, 11, "#D9D9D9"],
            [3, 11, "#D9D9D9"],
            [3, 10, "#D9D9D9"],
            [3, 9, "#D9D9D9"],
            [2, 10, "#FF00FF"],
            [2, 4, "#FF00FF"],
            [3, 6, "#D9D9D9"],
            [3, 7, "#D9D9D9"],
            [3, 8, "#D9D9D9"],
            [4, 3, "#D9D9D9"],
            [5, 3, "#D9D9D9"],
            [6, 3, "#D9D9D9"],
            [5, 11, "#D9D9D9"],
            [6, 11, "#D9D9D9"],
            [4, 11, "#D9D9D9"],
            [7, 3, "#D9D9D9"],
            [8, 3, "#CCCCCC"],
            [8, 4, "#CCCCCC"],
            [8, 5, "#CCCCCC"],
            [8, 6, "#CCCCCC"],
            [8, 7, "#CCCCCC"],
            [8, 8, "#CCCCCC"],
            [8, 9, "#CCCCCC"],
            [8, 10, "#CCCCCC"],
            [7, 11, "#D9D9D9"],
            [8, 11, "#CCCCCC"],
            [6, 5, "#FF0000"],
            [7, 6, "#FF0000"],
            [7, 7, "#FF0000"],
            [7, 8, "#FF0000"],
            [6, 9, "#FF0000"],
            [4, 5, "#666666"],
            [4, 9, "#666666"],
            [9, 3, "#CCCCCC"],
            [10, 2, "#CCCCCC"],
            [11, 1, "#CCCCCC"],
            [10, 3, "#CCCCCC"],
            [11, 3, "#CCCCCC"],
            [12, 3, "#CCCCCC"],
            [9, 11, "#CCCCCC"],
            [10, 11, "#CCCCCC"],
            [11, 11, "#CCCCCC"],
            [12, 11, "#CCCCCC"],
            [10, 12, "#CCCCCC"],
            [11, 13, "#CCCCCC"],
            [9, 5, "#D9D9D9"],
            [10, 5, "#D9D9D9"],
            [11, 5, "#D9D9D9"],
            [12, 5, "#D9D9D9"],
            [9, 4, "#D9D9D9"],
            [10, 4, "#D9D9D9"],
            [11, 4, "#D9D9D9"],
            [12, 4, "#D9D9D9"],
            [9, 6, "#D9D9D9"],
            [10, 6, "#D9D9D9"],
            [12, 6, "#D9D9D9"],
            [11, 6, "#D9D9D9"],
            [11, 7, "#D9D9D9"],
            [10, 7, "#D9D9D9"],
            [9, 7, "#D9D9D9"],
            [12, 7, "#D9D9D9"],
            [10, 8, "#D9D9D9"],
            [9, 8, "#D9D9D9"],
            [12, 8, "#D9D9D9"],
            [11, 8, "#D9D9D9"],
            [10, 9, "#D9D9D9"],
            [9, 9, "#D9D9D9"],
            [9, 10, "#D9D9D9"],
            [10, 10, "#D9D9D9"],
            [11, 10, "#D9D9D9"],
            [12, 10, "#D9D9D9"],
            [12, 9, "#D9D9D9"],
            [11, 9, "#D9D9D9"],
        ],
    },
    {
        date: 1585165984723,
        row: 12,
        col: 13,
        squares: [
            [4, 5, "#000000"],
            [4, 6, "#000000"],
            [4, 7, "#000000"],
            [4, 8, "#000000"],
            [2, 8, "#000000"],
            [2, 7, "#000000"],
            [2, 6, "#000000"],
            [2, 5, "#000000"],
            [3, 5, "#FF0000"],
            [3, 6, "#FF0000"],
            [3, 7, "#00FFFF"],
            [3, 8, "#00FFFF"],
            [1, 5, "#000000"],
            [1, 6, "#000000"],
            [1, 7, "#000000"],
            [1, 8, "#000000"],
            [5, 5, "#000000"],
            [6, 5, "#000000"],
            [7, 5, "#000000"],
            [5, 8, "#000000"],
            [6, 8, "#000000"],
            [7, 8, "#000000"],
            [7, 6, "#666666"],
            [7, 7, "#666666"],
            [6, 7, "#666666"],
            [6, 6, "#666666"],
            [5, 7, "#666666"],
            [5, 6, "#666666"],
            [8, 6, "#666666"],
            [8, 7, "#666666"],
            [9, 6, "#666666"],
            [9, 7, "#666666"],
            [10, 6, "#666666"],
            [10, 7, "#666666"],
            [1, 9, "#FF0000"],
            [1, 10, "#FF0000"],
            [1, 11, "#FF0000"],
            [1, 4, "#00FFFF"],
            [1, 3, "#00FFFF"],
            [1, 2, "#00FFFF"],
            [1, 1, "#00FFFF"],
            [1, 12, "#FF0000"],
            [1, 13, "#FF0000"],
            [2, 13, "#FF0000"],
            [2, 12, "#FF0000"],
            [2, 11, "#FF0000"],
            [2, 10, "#FF0000"],
            [2, 9, "#FF0000"],
            [3, 9, "#FF0000"],
            [3, 11, "#FF0000"],
            [3, 10, "#FF0000"],
            [3, 12, "#FF0000"],
            [3, 13, "#FF0000"],
            [6, 1, "#00FFFF"],
            [2, 1, "#00FFFF"],
            [2, 2, "#00FFFF"],
            [2, 3, "#00FFFF"],
            [2, 4, "#00FFFF"],
            [3, 4, "#00FFFF"],
            [3, 3, "#00FFFF"],
            [3, 1, "#00FFFF"],
            [3, 2, "#00FFFF"],
            [4, 1, "#00FFFF"],
            [4, 2, "#00FFFF"],
            [4, 3, "#00FFFF"],
            [4, 4, "#00FFFF"],
            [5, 3, "#00FFFF"],
            [5, 1, "#00FFFF"],
            [5, 2, "#00FFFF"],
            [6, 2, "#00FFFF"],
            [6, 3, "#00FFFF"],
            [7, 3, "#00FFFF"],
            [7, 2, "#00FFFF"],
            [7, 1, "#00FFFF"],
            [4, 9, "#FF0000"],
            [4, 10, "#FF0000"],
            [4, 11, "#FF0000"],
            [4, 12, "#FF0000"],
            [4, 13, "#FF0000"],
            [6, 13, "#FF0000"],
            [5, 13, "#FF0000"],
            [5, 12, "#FF0000"],
            [5, 11, "#FF0000"],
            [5, 10, "#FF0000"],
            [6, 10, "#FF0000"],
            [6, 12, "#FF0000"],
            [6, 11, "#FF0000"],
            [7, 10, "#FF0000"],
            [7, 11, "#FF0000"],
            [7, 12, "#FF0000"],
            [7, 13, "#FF0000"],
            [8, 5, "#FF0000"],
            [8, 4, "#FF0000"],
            [8, 3, "#FF0000"],
            [8, 2, "#FF0000"],
            [8, 1, "#FF0000"],
            [9, 1, "#FF0000"],
            [10, 1, "#FF0000"],
            [11, 1, "#FF0000"],
            [12, 1, "#FF0000"],
            [9, 2, "#FF0000"],
            [9, 3, "#FF0000"],
            [9, 4, "#FF0000"],
            [9, 5, "#FF0000"],
            [10, 5, "#FF0000"],
            [10, 4, "#FF0000"],
            [10, 3, "#FF0000"],
            [10, 2, "#FF0000"],
            [11, 2, "#FF0000"],
            [11, 3, "#FF0000"],
            [11, 4, "#FF0000"],
            [11, 5, "#FF0000"],
            [12, 5, "#FF0000"],
            [12, 4, "#FF0000"],
            [12, 3, "#FF0000"],
            [12, 2, "#FF0000"],
            [8, 8, "#00FFFF"],
            [8, 9, "#00FFFF"],
            [8, 10, "#00FFFF"],
            [8, 11, "#00FFFF"],
            [8, 13, "#00FFFF"],
            [8, 12, "#00FFFF"],
            [9, 13, "#00FFFF"],
            [9, 12, "#00FFFF"],
            [9, 11, "#00FFFF"],
            [9, 10, "#00FFFF"],
            [9, 9, "#00FFFF"],
            [9, 8, "#00FFFF"],
            [10, 9, "#00FFFF"],
            [10, 8, "#00FFFF"],
            [11, 8, "#00FFFF"],
            [12, 8, "#00FFFF"],
            [12, 9, "#00FFFF"],
            [11, 9, "#00FFFF"],
            [10, 10, "#00FFFF"],
            [10, 11, "#00FFFF"],
            [10, 13, "#00FFFF"],
            [10, 12, "#00FFFF"],
            [11, 13, "#00FFFF"],
            [11, 12, "#00FFFF"],
            [11, 11, "#00FFFF"],
            [11, 10, "#00FFFF"],
            [12, 10, "#00FFFF"],
            [12, 11, "#00FFFF"],
            [12, 12, "#00FFFF"],
            [12, 13, "#00FFFF"],
            [7, 4, "#000000"],
            [6, 4, "#000000"],
            [5, 4, "#000000"],
            [5, 9, "#000000"],
            [6, 9, "#000000"],
            [7, 9, "#000000"],
            [11, 7, "#00FFFF"],
            [12, 7, "#00FFFF"],
            [11, 6, "#FF0000"],
            [12, 6, "#FF0000"],
        ],
    },
    {
        date: 1445438181081,
        row: 12,
        col: 13,
        squares: [
            [1, 1, "#000000"],
            [1, 3, "#000000"],
            [1, 5, "#000000"],
            [1, 7, "#000000"],
            [1, 9, "#000000"],
            [1, 11, "#000000"],
            [2, 12, "#000000"],
            [2, 10, "#000000"],
            [2, 8, "#000000"],
            [2, 6, "#000000"],
            [2, 4, "#000000"],
            [2, 2, "#000000"],
            [1, 13, "#000000"],
            [3, 1, "#000000"],
            [3, 3, "#000000"],
            [3, 5, "#000000"],
            [3, 7, "#000000"],
            [3, 9, "#000000"],
            [3, 11, "#000000"],
            [3, 13, "#000000"],
            [4, 12, "#000000"],
            [4, 10, "#000000"],
            [4, 8, "#000000"],
            [4, 6, "#000000"],
            [4, 4, "#000000"],
            [4, 2, "#000000"],
            [5, 13, "#000000"],
            [5, 11, "#000000"],
            [5, 9, "#000000"],
            [5, 7, "#000000"],
            [5, 5, "#000000"],
            [5, 3, "#000000"],
            [5, 1, "#000000"],
            [6, 2, "#000000"],
            [6, 4, "#000000"],
            [6, 6, "#000000"],
            [6, 8, "#000000"],
            [6, 10, "#000000"],
            [6, 12, "#000000"],
        ],
    },
];
